import { Box, ScaleFade, Slide, Spinner, Stack, Text } from "@chakra-ui/react";
import { getCurrentBrowserFingerPrint } from "@rajesh896/broprint.js";
import axios from "axios";
import tinycolor from "tinycolor2";
import { debounce, zip } from "lodash";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { GrFormClose } from "react-icons/gr";
import { IoIosArrowDown } from "react-icons/io";
import { SiNuget } from "react-icons/si";
import { useLocation } from "react-router-dom";

import { TfiHeadphoneAlt } from "react-icons/tfi";
import { getSessionId } from "../client/sessionSetup";
import {
  checkLoginUserid,
  createOrConnectRoom,
  getUserChat,
  sendDataToConnectedUser,
  sendKafkaEvent,
} from "../client/wss";
import appstore from "../store/appStore";
import { BotLogo } from "./components/BotLogo";

import { TriviaDetails } from "./components/TriviaDetails";
import DraggableBox from "./Drag";
import { motion } from "framer-motion";
import { use } from "react";

const transformData = (data) => {
  const result = [];
  let tempGroup = [];

  data.forEach((item) => {
    if (item.text && item.text.props && "ele" in item.text.props) {
      tempGroup.push(item);
    } else {
      if (tempGroup.length > 0) {
        result.push(tempGroup);
        tempGroup = [];
      }
      result.push(item);
    }
  });

  if (tempGroup.length > 0) {
    result.push(tempGroup);
  }

  return result;
};

export default function Home({ botid }) {
  const {
    messages,
    setMessages,
    setBotDetails,
    botDetails,
    suggestions,
    showTyping,
    getShopifyCart,
    getBigcommerceCart,
    setSuggestions,
    setMessagesToNewChat,
    mycart,
    addCreateCartUlai,
    updateShopifyCart,
  } = appstore();

  const MotionDiv = motion.div;

  const getRandomIntExclusive = (min, max) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min)) + min;
  };
  // const [transformedData, setTransformedData] = useState([]);
  const [isloading, setLoading] = useState(false);
  const [isConvoHide, setIsConvoHide] = useState(false);
  const [triviaDetails, setTriviaDetails] = useState({
    isActive: false,
    trivia: {
      trivia:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Inventore neque laboriosam cumque, consequuntur laborum voluptatibus recusandae exercitationem incidunt fugit fugiat vitae laudantium quia eos assumenda atque consectetur debitis earum dolores!",
      butttons: [{ text: "Know more" }, { text: "Thanks" }],
    },
  });

  const [initialCallMade, setInitialCallMade] = useState(false);
  const [clickedKnowMoreAboutit, setClickedKnowMoreAboutit] = useState({
    text: "",
    isClicked: false,
  });
  const location = useLocation();
  const [storeAllSuggestion, storeAllSuggestions] = useState(null);
  const [contactUsMsgSend, setIsContactUsMsgSend] = useState({
    isSend: false,
    inputDetails: { fullName: "", email: "", msg: "" },
  });
  const [conversationStart, setIsConversationStart] = useState({
    isStart: false,
    inputDetails: { email: "", phone: "" },
  });
  const [trackOrderSearched, setTrackOrderSearched] = useState({
    isSearched: false,
    notFound: false,
    detail: { status: "", orderNo: "", trackLink: "", subTotal: "" },
    inputDetails: { orderNo: "", phoneOrEmail: "" },
  });

  const [botOpen, setBotOpen] = useState(false);
  const [currentChatPanelview, setCurrentChatPanelview] = useState("Home");
  const [floatOpen, setFloatOpen] = useState(() => {
    return true;
  });
  let currentTime = "";
  const messagesContainerRef = useRef(null);
  const [TriviaTimer, setTriviaTimer] = useState(null);
  const [userMessage, setUserMessage] = useState("");
  const [rufusQue, setRufusQues] = useState([]);
  const [isMobile, setIsMobile] = useState(false);
  const [isAskingRating, setAskingRating] = useState(false);
  const [showEndConv, setShowEndConv] = useState(false);
  const [rating, setRating] = useState(0);
  const [error, setError] = useState(false);
  const [inputStr, setInputStr] = useState("");
  const [showPicker, setShowPicker] = useState(false);
  const [scrolled, setScrolled] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [productId, setProId] = useState("");
  const [clicked, setClicked] = useState(false);
  const [hideBot, setHideBot] = useState(false);
  const [draggableBoxHeight, setDraggableBoxHeight] = useState(0);
  const [loading1, setLoading1] = useState(false);
  const [askiiClicke, setAskiiClicked] = useState(false);
  const [iframeSrc, setIframeSrc] = useState("");
  const [boxHeight, setBoxHeight] = useState(75);
  const [qtyData, setQtyData] = useState({});
  const handleClick = () => {
    setClicked(true);
    setTimeout(() => {
      setClicked(false);
    }, 2000); // Reset after animation (optional)
  };

  const particles = Array.from({ length: 25 }, (_, i) => ({
    id: i,
    x: (Math.random() - 0.5) * 700,
    y: (Math.random() - 0.5) * 700,
    scale: Math.random() * 1.5 + 0.5,
  }));
  useEffect(() => {
    if (rufusQue?.length > 0) {
      handleClick();
      setBotOpen(false);
    }
  }, [rufusQue]);
  // Toggle drawer visibility
  const toggleDrawer = () => {
    setIsOpen((prevState) => !prevState);
  };

  const onEmojiClick = (emojiObject, event) => {
    if (emojiObject && emojiObject.emoji) {
      setUserMessage((prevInput) => prevInput + emojiObject.emoji);
    }

    setShowPicker(false);
  };

  const openCart = async () => {
    if (botDetails.storeName === "Shopify") {
      await getShopifyCart();
    }
    setCurrentChatPanelview("mycart");
  };
  const handleQty = async (qty, varientId, productId, itemId) => {
    if (botDetails.storeName === "Shopify") {
      let item = {
        id: `${varientId}`,
        quantity: qty,
      };

      // console.log("calling handle,'============>")
      const response = await axios
        .post(window?.Shopify?.routes?.root + "cart/change.js", item, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then(async (response) => {
          const resp = await axios(window?.Shopify?.routes?.root + "cart.js", {
            method: "GET",
          });
          // console.log("done,'============>")
          let cart = await resp.data;
          updateShopifyCart(cart);
          let productArray = [];
          cart.items.forEach((element) => {
            productArray.push({
              productId: element.product_id,
              quantity: element.quantity,
              varient: [{ varientId: element.variant_id }],
            });
          });
          let totalPrice = cart?.total_price.toString();
          let subTotal = cart?.items_subtotal_price.toString();
          addCreateCartUlai(
            cart.token,
            botDetails?.userId,
            productArray,
            Number(
              `${totalPrice.slice(0, totalPrice.length - 2)}.${totalPrice.slice(
                -2
              )}`
            ),
            Number(
              `${subTotal.slice(0, subTotal.length - 2)}.${subTotal.slice(-2)}`
            )
          );
          setQtyData(null);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          return error;
        });
    } else if (botDetails.storeName === "Bigcommerce") {
      const options = {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: `{"lineItem":{"quantity":${qty},"productId":${productId},"variantId":${varientId}}}`,
      };
      // console.log("localStorage", localStorage.getItem("cartId"));
      setLoading(true);
      const response = await fetch(
        `/api/storefront/carts/${localStorage.getItem(
          "cartId"
        )}/items/${itemId}?include=lineItems.physicalItems.options`,
        options
      )
        .then((response) => response.json())
        .catch((err) => console.error(err));

      if (response) {
        let tempList = [];
        let productArray = [];
        response.lineItems?.physicalItems?.forEach((element) => {
          tempList.push(element?.productId);
          productArray.push({
            productId: element?.productId,
            quantity: element?.quantity,
            varient: [{ varientId: element?.variantId }],
          });
        });
        let totalPrice = response?.cartAmount;
        let subTotal = response?.baseAmount?.toString();

        let cart = await getBigcommerceCart();
        const chatbotFrame = document.getElementById("chatbot-iframe"); // Get iframe by ID
        if (chatbotFrame) {
          // console.log("sending shopifyCartUpdate,'============>")
          chatbotFrame.contentWindow.postMessage(
            {
              type: "bigComCartUpdate",
              bigComCartData: {
                response,
                botDetails,
                productArray,
                totalPrice,
                subTotal,
              },
            },
            "*"
          );
        }
        // addCreateCartUlai(
        //   response?.id,
        //   botDetails?.userId,
        //   productArray,
        //   totalPrice,
        //   subTotal
        // );
      }
      setLoading(false);
    }
  };
  const isColorDark = (color) => {
    const colorObj = tinycolor(color);
    return colorObj.isDark();
  };
  const closeTrivia = () => {
    setTriviaDetails({ ...triviaDetails, isActive: false });
  };

  useEffect(() => {
    localStorage.setItem("floatOpen", floatOpen);
  }, [floatOpen]);

  const openChatBotFromTrivia = () => {
    const websdkOpen = localStorage.getItem("ul-websdk_bot_open") || false;
    if (botOpen == false && websdkOpen == false) {
      localStorage.setItem("ul-websdk_bot_open", true);
      sendKafkaEvent({
        eventName: "websdk_bot_open",
        userId: botDetails.userId,
        chatId: getSessionId(localStorage.getItem("sessionUUID")),
      });
    }
    setBotOpen(true);
    // appstore.getState().setShowSuggestions(true);
    setFloatOpen(false);
  };

  const sendMessageToBotDirectly = async (msg) => {
    openChatBotFromTrivia();
    setIsConversationStart({ ...conversationStart, isStart: true });
    await setCurrentChatPanelview("conversation");
    appstore.getState().setShowSuggestions(false);
    const currentTime = new Date().toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    const sendData = JSON.stringify({
      identity: "USER",
      message: msg,
      roomId: getSessionId(localStorage.getItem("sessionUUID")),
      organization_id: botDetails.userId,
      type: botDetails.botType,
      time: "",
      bot_id: botDetails._id,
      domain: window.location.origin,
      companyName: botDetails.companyName,
      uid: botDetails.sqlId,
      unqiueBrowserId: await getCurrentBrowserFingerPrint(),
    });
    if (msg.length > 0) {
      sendDataToConnectedUser(sendData);
      setMessages(msg, true, currentTime);
      setUserMessage("");
    }
    setClickedKnowMoreAboutit({
      ...clickedKnowMoreAboutit,
      isClicked: false,
    });
  };

  const openChatBot = () => {
    // if (!isMobile) setLoading1(true);

    const websdkOpen = localStorage.getItem("ul-websdk_bot_open") || false;
    if (botOpen == false && websdkOpen == false) {
      localStorage.setItem("ul-websdk_bot_open", true);
      sendKafkaEvent({
        eventName: "websdk_bot_open",
        userId: botDetails.userId,
        chatId: getSessionId(localStorage.getItem("sessionUUID")),
      });
    }
    setBotOpen((prev) => !prev);

    appstore.getState().setShowSuggestions(true);

    setFloatOpen((prev) => !prev);

    const chatbotFrame = document.getElementById("chatbot-iframe"); // Get iframe by ID
    if (chatbotFrame) {
      chatbotFrame.contentWindow.postMessage(
        { type: "suggestion", suggestion: true },
        "*"
      );
    }
  };

  const closeFloatingChat = (event) => {
    setFloatOpen((prev) => false);
  };

  const onSuggestionSelected = async (data) => {
    appstore.getState().setShowSuggestions(false);
    // console.log("Data", data, typeof data);
    // setUserMessage(data);
    // sendMessageToBot();
    // console.log("User message", userMessage);
    const currentTime = new Date().toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
    const sendData = JSON.stringify({
      identity: "USER",
      message: data,
      roomId: getSessionId(localStorage.getItem("sessionUUID")),
      organization_id: botDetails.userId,
      type: botDetails.botType,
      time: "",
      bot_id: botDetails._id,
      domain: window.location.origin,
      uid: "tbJLwRYgT2aBODyMdtn6YS9BZxszuAYi",
      socket_id: "",
      unqiueBrowserId: await getCurrentBrowserFingerPrint(),
    });
    // console.log("sendMessageToBot", sendData);
    sendDataToConnectedUser(sendData);
    setMessages(data, true, currentTime);

    setUserMessage("");
  };

  useEffect(() => {
    (async () => {
      setLoading1(true);
      try {
        axios(
          `${process.env.REACT_APP_API_BASE_URL}/bot/${botid}`,
          // "http://localhost:3001/bot/652150accd05a75edb9de2bf",
          {
            method: "GET",
          }
        )
          .then(async function (resp) {
            if (resp.data) {
              const sessionId = getSessionId(
                localStorage.getItem("sessionUUID")
              );

              setIframeSrc(
                `https://${
                  process.env.REACT_APP_IFRAME
                }?botId=${botid}&sessionId=${getSessionId(
                  localStorage.getItem("sessionUUID")
                )}&cartId=${window?.Shopify?.routes?.root}&origin=${
                  window.location.origin
                }&href=${window.location.href}`
              );

              createOrConnectRoom();
              if (
                resp.data?.triviaLoaderTime &&
                resp.data?.triviaLoaderTime > 99
              ) {
                console.log("triviaLoaderTime", resp.data?.triviaLoaderTime);
                setTriviaDetails({
                  ...triviaDetails,
                  isActive: true,
                  timer: resp.data?.triviaLoaderTime,
                });
              }
              storeAllSuggestions(resp.data.initialChatsuggestions);
              setSuggestions(resp.data.initialChatsuggestions);
              // getUserChat(getSessionId(localStorage.getItem("sessionUUID")));
              if (resp.data.storeName === "Bigcommerce") {
                // await getBigcommerceCart();
              } else if (resp.data.storeName === "Shopify") {
                // await getShopifyCart();
              }
              let flag = false;
              if (resp?.data?.menuSection?.conversation == false) {
                setIsConvoHide(true);
                if (resp?.data?.menuSection?.trackOrder) {
                  setCurrentChatPanelview("trackOrder");
                } else if (resp?.data?.menuSection?.contactUs) {
                  setCurrentChatPanelview("contactUs");
                } else {
                  flag = true;
                }
              }
              if (!flag) {
                if (resp.data?.whatsappRedirectLink) {
                  setBotDetails(resp.data);
                } else {
                  setBotDetails({
                    ...resp.data,
                    menuSection: { ...resp.data.menuSection, whatsapp: false },
                  });
                }
                setInitialCallMade(true);
              }
            }
          })
          .catch((err) => {
            console.log("err", err);
          });
      } catch (error) {
        console.log("error", error);
      }
    })();
  }, []);

  const handleDebounce = useMemo(
    () =>
      debounce((e) => {
        setShowEndConv(true);
      }, 20000),
    []
  );
  useEffect(() => {}, [botOpen]);

  const handleSubmitReview = () => {
    sendKafkaEvent({
      eventName: "websdk_chat_review",
      userId: botDetails.userId,
      rating: rating,
      chatId: getSessionId(localStorage.getItem("sessionUUID")),
    });
    setIsConversationStart({
      isStart: true,
      inputDetails: { email: "", phone: "" },
    });
    setAskingRating(false);
    setShowEndConv(false);
    getSessionId();
    openChatBot();
    setMessagesToNewChat();
    setRating(0);
    setSuggestions(storeAllSuggestion);
    createOrConnectRoom();
    setCurrentChatPanelview("Home");
    setFloatOpen(true);
  };
  const MAX_ATTEMPTS = 20;
  useEffect(() => {
    let attempts = 0;

    if (botDetails?.userId) {
      const checkCid = () => {
        if (window?.__st?.cid) {
          checkLoginUserid(
            botDetails?.userId,
            getSessionId(localStorage.getItem("sessionUUID"))
          );
        } else if (attempts < MAX_ATTEMPTS) {
          attempts++;
          setTimeout(checkCid, 500); // Poll every 100ms
        } else {
          // Stop polling and show an error if it never loads
        }
      };

      checkCid();
    } // Initial check

    // Check if the device is mobile
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 500); // Adjust the threshold as needed
    };

    handleResize(); // Check initially
    window.addEventListener("resize", handleResize); // Listen for window resize events

    return () => {
      window.removeEventListener("resize", handleResize); // Cleanup event listener
    };
  }, [botDetails?.userId]);
  const handleTrackOrder = async (e) => {
    e.preventDefault();
    let data = JSON.stringify({
      storeOrderId: `%23${trackOrderSearched.inputDetails.orderNo}`,
      phoneOrEmail: trackOrderSearched.inputDetails.phoneOrEmail,
      userId: botDetails.userId,
    });

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_BASE_URL}/order/getEcomOrder`,
      headers: {
        xAuthKey:
          "57f78d0a63d6e6b1c41c3d05848645a6c0d446d23f9c1d732b61ce3a78459418",
        "Content-Type": "application/json",
      },
      data: data,
    };
    try {
      setLoading(true);
      const respData = await axios.request(config);
      // console.log("data", respData.data);
      if (respData.data.success) {
        setTrackOrderSearched({
          isSearched: true,
          notFound: false,
          detail: {
            status: respData.data.orderStatus,
            orderNo: respData.data.storeOrderId,
            trackLink: respData.data.orderStatusUrl,
            subTotal: respData.data.subtotal,
          },
        });
      } else {
        setTrackOrderSearched({
          ...trackOrderSearched,
          isSearched: true,
          notFound: true,
        });
      }
      setLoading(false);
    } catch (error) {
      console.log("data", error);
      setTrackOrderSearched({
        ...trackOrderSearched,
        isSearched: true,
        notFound: true,
      });
      setLoading(false);
    }
  };
  const handleStartConversation = async (e) => {
    e.preventDefault();

    if (
      botDetails.askEmail ||
      conversationStart.inputDetails.phone.length == 10
    ) {
      setError(false);

      let data = JSON.stringify({
        userId: botDetails.userId,
        sessonId: getSessionId(localStorage.getItem("sessionUUID")),
        phone: botDetails.askPhone
          ? conversationStart.inputDetails.phone
          : null,
        email: botDetails.askEmail
          ? conversationStart.inputDetails.email
          : null,
      });

      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_API_BASE_URL}/customerInformation/add`,
        headers: {
          xAuthKey:
            "57f78d0a63d6e6b1c41c3d05848645a6c0d446d23f9c1d732b61ce3a78459418",
          "Content-Type": "application/json",
        },
        data: data,
      };
      try {
        setLoading(true);
        const respData = await axios.request(config);
        // console.log("data", respData.data);
        setIsConversationStart({ ...conversationStart, isStart: true });
        localStorage.setItem("isConStart", true);
        setCurrentChatPanelview("conversation");
        if (clickedKnowMoreAboutit.isClicked) {
          sendMessageToBotDirectly(clickedKnowMoreAboutit.text);
        }
        setLoading(false);
      } catch (error) {
        // console.log("data", error);
        setLoading(false);
      }
    } else if (conversationStart.inputDetails.phone.length != 10) {
      // console.log(conversationStart.inputDetails.phone.length);
      setError(true);
    }
  };
  const handleContactUs = async (e) => {
    e.preventDefault();
    let data = JSON.stringify({
      userId: botDetails.userId,
      sessonId: getSessionId(localStorage.getItem("sessionUUID")),
      fullName: contactUsMsgSend.inputDetails.fullName,
      email: contactUsMsgSend.inputDetails.email,
      msg: contactUsMsgSend.inputDetails.msg,
    });

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_BASE_URL}/contactus/add`,
      headers: {
        xAuthKey:
          "57f78d0a63d6e6b1c41c3d05848645a6c0d446d23f9c1d732b61ce3a78459418",
        "Content-Type": "application/json",
      },
      data: data,
    };
    try {
      setLoading(true);
      const respData = await axios.request(config);
      // console.log("data", respData.data);
      setLoading(false);
      setIsContactUsMsgSend({ ...contactUsMsgSend, isSend: true });
    } catch (error) {
      console.log("data", error);
      setLoading(false);
    }
  };
  async function knowMoreAboutIt(text) {
    if (
      botDetails.askDetailsBeforeChat &&
      !conversationStart.isStart &&
      (botDetails.askEmail || botDetails.askPhone)
    ) {
      setClickedKnowMoreAboutit({
        text: text,
        isClicked: true,
      });
      setTriviaDetails({ ...triviaDetails, isActive: false });

      openChatBot();
    } else {
      setTriviaDetails({ ...triviaDetails, isActive: false });
      sendMessageToBotDirectly(text);
    }
  }
  function startChatFromTrivia() {
    if (
      botDetails.askDetailsBeforeChat &&
      !conversationStart.isStart &&
      (botDetails.askEmail || botDetails.askPhone)
    ) {
      setTriviaDetails({ ...triviaDetails, isActive: false });
      openChatBot();
    } else {
      setIsConversationStart({ ...conversationStart, isStart: true });
      setTriviaDetails({ ...triviaDetails, isActive: false });
      setCurrentChatPanelview("conversation");
      openChatBot();
    }
  }

  useEffect(() => {
    // This effect will run whenever the URL path changes
    if (botDetails.userId) {
      const urlParams = new URLSearchParams(window.location.search);
      const myParam = urlParams.get("startbotcon");
      if (myParam) {
        const startPromt = urlParams.get("startpromt");
        if (botDetails?.menuSection?.conversation != false) {
          if (startPromt) {
            knowMoreAboutIt(startPromt);
          } else {
            startChatFromTrivia();
          }
        }
      } else {
        (async () => {
          setLoading1(true);
          try {
            const resp = await axios.get(
              `https://${process.env.REACT_APP_API_BASE_CUSTDOMAIN}/backend/trivia?userId=${botDetails.userId}&pagePath=${location.pathname}`
            );
            setTriviaDetails({
              ...triviaDetails,
              isActive: true,
              trivia:
                resp?.data?.trivias[
                  getRandomIntExclusive(0, resp?.data?.trivias.length)
                ],
            });
          } catch (error) {
            setTriviaDetails({
              ...triviaDetails,
              isActive: false,
            });
          }
        })();
      }
    }
  }, [botDetails?.userId, location.pathname]);
  useEffect(() => {
    if (botDetails.userId) {
      if (botDetails?.rufus && window.meta?.product?.id) {
        const fetchQuestions = async () => {
          setLoading1(true);
          try {
            const response = await axios.post(
              `https://${process.env.REACT_APP_API_BASE_SOCKET}/api/ai/questions`,
              {
                organization_id: botDetails.userId,
                product_id: `${window.meta?.product?.id}`,
                // product_id: "8246213050518",
                // "8246213050518"
                // `${window.meta?.product?.id}`
              }
            );
            //  console.log(response.data.data.questions,"========+>fdfdfd")
            toggleDrawer();

            const shortQue = response.data.data.questions.sort(
              (a, b) => a.length - b.length
            );
            setRufusQues(shortQue);
            setLoading1(false);
          } catch (err) {
            setLoading1(false);
            console.log(err);
          }
        };

        fetchQuestions();
      }
    }
  }, [window.meta?.product?.id, botDetails.userId]);
  useEffect(() => {
    if (botOpen&&isMobile) {
      document.body.style.overflow = "hidden"; // Disable scrolling on the website
      document.documentElement.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto"; // Enable scrolling back when chatbot closes
      document.documentElement.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
      document.documentElement.style.overflow = "auto";
    };
  }, [botOpen]);

  const [displayTriviaComponent, setDisplayTriviaComponent] = useState(false); //set your preferences here
  useEffect(() => {
    var isConStart = localStorage.getItem("isConStart") || false;
    if (isConStart && botOpen) {
      const event = { preventDefault: () => {} };
      setIsConversationStart({ ...conversationStart, isStart: true });
      setCurrentChatPanelview("conversation");
    }

    if (triviaDetails.isActive && triviaDetails.timer) {
      setTimeout(() => {
        // console.log("triviaDetails.timer",triviaDetails.timer)
        setDisplayTriviaComponent(true);
      }, [triviaDetails.timer]);
    }
    if (isMobile) {
      const delay = setTimeout(() => {
        setHideBot(true);
        // console.log(hideBot)
        clearTimeout(delay);
      }, 1000);
      if (hideBot) {
        let height = 10;

        const transition = setInterval(() => {
          setDraggableBoxHeight((prev) => {
            if (prev >= 75) {
              clearInterval(transition);
              return 75;
            }
            return prev + 5;
          });
        }, 50);
      }
    }
  }, [botOpen, triviaDetails, hideBot]);
  // Only depend on botOpen for toggling

  //shopifyFlow call
  const shopifyFlow = async (formData) => {
    try {
      // console.log("shopifyFlow", formData);
      const response = await fetch(
        window?.Shopify?.routes?.root + "cart/add.js",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      )
        .then(async (response) => {
          // console.log(response,"=======++>>")
          if (response?.status === 200) {
            const resp = await fetch(
              window?.Shopify?.routes?.root + "cart.js",
              {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                },
              }
            );
            let cart = await resp.json();
            // console.log(cart,"=======++>>")
            const chatbotFrame = document.getElementById("chatbot-iframe");
            if (chatbotFrame) {
              chatbotFrame.contentWindow.postMessage(
                {
                  type: "shopifyFlowData",
                  shopifyFlowData: cart,
                  loading: false,
                },
                "*"
              );
            }
          }
        })
        .catch((error) => {
          return error;
        });
    } catch (error) {
      // Handle general errors
      console.error("Error in shopifyFlow:", error);
      return { error: error.message };
    }
  };

  const bigcommerceFlow = async (options) => {
    try {
      // console.log(cartId + "cart/add.js======================+> clicked")

      console.log("localStorage", localStorage.getItem("cartId"));
      const response = await fetch(
        localStorage.getItem("cartId")
          ? `/api/storefront/carts/${localStorage.getItem(
              "cartId"
            )}/items?include=lineItems.physicalItems.options`
          : "/api/storefront/carts?include=lineItems.physicalItems.options",
        options
      )
        .then((response) => response.json())
        .catch((err) => console.error(err));
      if (response) {
        console.log("response", response);

        let tempList = [];
        let productArray = [];
        response.lineItems?.physicalItems?.forEach((element) => {
          tempList.push(element?.productId);
          productArray.push({
            productId: element?.productId,
            quantity: element?.quantity,
            varient: [{ varientId: element?.variantId }],
          });
        });
        let totalPrice = response?.cartAmount;
        let subTotal = response?.baseAmount?.toString();

        let cart = await getBigcommerceCart();
        const chatbotFrame = document.getElementById("chatbot-iframe");
        if (chatbotFrame) {
          chatbotFrame.contentWindow.postMessage(
            {
              type: "bigComFlowData",
              bigComFlowData: {
                response,
                totalPrice,
                subTotal,
                cart,
                productArray,
              },
              loading: false,
            },
            "*"
          );
        }
      }
    } catch (error) {
      console.error("Error in bigcommerceFlow:", error);
    }
  };
  useEffect(() => {
    const chatbotFrame = document.getElementById("chatbot-iframe"); // Get iframe by ID
    if (chatbotFrame)
      chatbotFrame.contentWindow.postMessage(
        {
          type: "botOpen",
          botOpen,
        },
        "*"
      );
  }, [botOpen]);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data.type === "botOpen") {
        setBotOpen(event.data.botOpen);
      } else if (event.data.type == "botLoad") {
        setLoading1(event.data.botLoad);
      } else if (event.data.type == "boxHeight") {
        setBoxHeight(event.data.boxHeight);
      } else if (event.data.type == "ShopifyCall") {
        getShopifyCart();
      } else if (event.data.type == "bigComCall") {
        getBigcommerceCart();
      } else if (event.data.type == "shopifyFlow") {
        shopifyFlow(event.data.formData);
      } else if (event.data.type == "bigComFlow") {
        bigcommerceFlow(event.data.options);
      } else if (event.data.type == "shopifyHandleQty") {
        // console.log("===========>hopifyHandleQty")
        setQtyData({
          qty: event.data.qty,
          variantId: event.data.varientId,
          productId: event.data.productId,
          itemId: event.data.itemId,
        });
      } else if (event.data.type == "checkoutHref") {
        window.location.href = event.data.cartPath;
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);
  useEffect(() => {
    if (qtyData) {
      handleQty(
        qtyData.qty,
        qtyData.variantId,
        qtyData.productId,
        qtyData.itemId
      );
    }
  }, [qtyData]);

  return (
    initialCallMade && (
      <Box>
        <Box
          className="chatbot-main-container"
          pos={"fixed"} // Adjust position based on mobile or desktop
          bottom={
            isMobile
              ? botDetails.bottomPlacementMobile
              : botDetails.bottomPlacement
          } // Set bottom position for mobile or use botDetails.bottomPlacement
          right={
            isMobile
              ? botDetails.rightPlacementMobile
              : botDetails.rightPlacement
          }
          zIndex={2147483647}
        >
          {isMobile && window.meta?.product?.id ? null : (
            <div style={{ display: botOpen ? "block" : "none" }}>
              <iframe
                id="chatbot-iframe"
                src={iframeSrc}
                className="chat-bot-container"
              ></iframe>
            </div>
          )}
          {botOpen ? (
            <></>
          ) : // <iframe src={`http://${process.env.REACT_APP_IFRAME}?botId=${botid}&sessionId=${getSessionId(localStorage.getItem("sessionUUID"))}`} style={{display:loading1?"none":"block"}} className="chat-bot-container" onLoad={handleLoad}  ></iframe>
          rufusQue?.length > 0 ? (
            <>
              {isMobile && hideBot ? (
                <DraggableBox
                  iframeSrc={iframeSrc}
                  boxHeight={boxHeight}
                  setBoxHeight={setBoxHeight}
                  setAskiiClicked={setAskiiClicked}
                  setSuggestions={setSuggestions}
                  height={draggableBoxHeight}
                  botDetails={botDetails}
                  toggleDrawer={toggleDrawer}
                  rufusQue={rufusQue}
                  isColorDark={isColorDark}
                  botOpen={botOpen}
                  openCart={openCart}
                  setScrolled={setScrolled}
                  conversationStart={conversationStart}
                  contactUsMsgSend={contactUsMsgSend}
                  floatOpen={floatOpen}
                  currentChatPanelview={currentChatPanelview}
                  openChatBot={openChatBot}
                  setTrackOrderSearched={setTrackOrderSearched}
                  setIsContactUsMsgSend={setIsContactUsMsgSend}
                  setCurrentChatPanelview={setCurrentChatPanelview}
                  handleContactUs={handleContactUs}
                  handleTrackOrder={handleTrackOrder}
                  knowMoreAboutIt={knowMoreAboutIt}
                  handleQty={handleQty}
                  mycart={mycart}
                  trackOrderSearched={trackOrderSearched}
                  isloading={isloading}
                  isConvoHide={isConvoHide}
                  clickedKnowMoreAboutit={clickedKnowMoreAboutit}
                  handleStartConversation={handleStartConversation}
                  setIsConversationStart={setIsConversationStart}
                  messagesContainerRef={messagesContainerRef}
                  showTyping={showTyping}
                  scrolled={scrolled}
                  suggestions={suggestions}
                  onSuggestionSelected={onSuggestionSelected}
                  isAskingRating={isAskingRating}
                  showEndConv={showEndConv}
                  setAskingRating={setAskingRating}
                  userMessage={userMessage}
                  setUserMessage={setUserMessage}
                  setShowPicker={setShowPicker}
                  showPicker={showPicker}
                  onEmojiClick={onEmojiClick}
                  setRating={setRating}
                  rating={rating}
                  botid={botid}
                  handleSubmitReview={handleSubmitReview}
                  error={error}
                />
              ) : floatOpen ? (
                <Box
                  display={"flex"}
                  flexDirection={"column"}
                  justifyContent={"flex-start"}
                  alignItems={"flex-end"} /* Align all children to the right */
                >
                  {rufusQue?.length > 0 && !isMobile && (
                    <Stack
                      spacing={3}
                      justifyContent={"flex-end"}
                      alignItems={"flex-end"}
                    >
                      <Box
                        p={"0px"}
                        maxWidth={"280px"}
                        width={"fit-content"}
                        mb={"4px"}
                        cursor={"pointer"}
                        bgColor={"transparent"}
                        display={"flex"}
                        justifyContent={"flex-end"}
                        alignItems={"center"}
                      >
                        <Box onClick={closeFloatingChat}>
                          <GrFormClose fontSize={"20px"} />
                        </Box>
                      </Box>
                      {rufusQue.map((ele, i) => (
                        <Box
                          key={i}
                          p={3}
                          borderWidth="1px"
                          borderColor={botDetails.accentColor}
                          borderRadius="20px"
                          maxWidth="300px"
                          width="fit-content"
                          bg="white"
                          cursor="pointer"
                          boxShadow="0px 2px 6px rgba(0, 0, 0, 0.15)"
                          _hover={{
                            bg: "gray.50",
                            transform: "scale(1.02)",
                            transition: "0.2s",
                          }}
                          onClick={(event) => {
                            if (
                              botDetails.askDetailsBeforeChat &&
                              !conversationStart.isStart &&
                              (botDetails.askEmail || botDetails.askPhone)
                            ) {
                              const chatbotFrame =
                                document.getElementById("chatbot-iframe"); // Get iframe by ID
                              if (chatbotFrame)
                                chatbotFrame.contentWindow.postMessage(
                                  {
                                    type: "rufusTextKnow",
                                    rufusText: ele,
                                    askii: false,
                                    productId: null,
                                  },
                                  "*"
                                );
                              openChatBot();
                            } else {
                              const chatbotFrame =
                                document.getElementById("chatbot-iframe"); // Get iframe by ID
                              if (chatbotFrame) {
                                chatbotFrame.contentWindow.postMessage(
                                  {
                                    type: "rufusText",
                                    rufusText: ele,
                                    askii: false,
                                    productId: null,
                                  },
                                  "*"
                                );
                              }
                              // sendMessageToBot(event, ele);
                              openChatBot();
                              setSuggestions(null);
                            }
                          }}
                        >
                          <Text
                            fontSize="14px"
                            fontWeight="500"
                            textAlign="right"
                          >
                            {ele}
                          </Text>
                        </Box>
                      ))}
                    </Stack>
                  )}
                </Box>
              ) : null}
            </>
          ) : triviaDetails.isActive && displayTriviaComponent ? (
            <TriviaDetails
              triviaDetails={triviaDetails}
              botDetails={botDetails}
              knowMoreAboutIt={knowMoreAboutIt}
              startChatFromTrivia={startChatFromTrivia}
              isColorDark={isColorDark}
              isloading={isloading}
              closeTrivia={closeTrivia}
              openChatBot={openChatBot}
            />
          ) : floatOpen ? (
            <Box>
              <Box
                p={"14px"}
                width={"280px"}
                mb={"16px"}
                cursor={"pointer"}
                bgColor={"transparent"}
              >
                <Box float={"right"} onClick={closeFloatingChat}>
                  <GrFormClose fontSize={"20px"} />
                </Box>
              </Box>
              {/* <Box float={"right"} onClick={closeFloatingChat} mb={"16px"}>
                <GrFormClose fontSize={"20px"} />
              </Box> */}

              <Box
                p={"14px"}
                border={`1px solid ${botDetails.accentColor}`}
                boxShadow={`rgba(14, 30, 37, 0.12) 0px 0px 0px 0px, rgba(14, 30, 37, 0.12)0px 1px 4px 0px`}
                // boxShadow={`rgba(14, 30, 37, 0.12) 0px 0px 0px 0px, ${botDetails.accentColor} 0px 1px 4px 0px`}
                borderRadius={"30px"}
                width={"280px"}
                mb={"16px"}
                onClick={openChatBot}
                cursor={"pointer"}
                style={{ background: "white" }}
              >
                {/* <Box float={"right"} onClick={closeFloatingChat}>
                  <GrFormClose fontSize={"20px"} />
                </Box> */}
                <Box
                  float={"left"}
                  w={"25px"}
                  h={"25px"}
                  mr={"12px"}
                  mb={"10px"}
                  borderRadius={"50%"}
                  bg={botDetails?.accentColor}
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"center"}
                  boxShadow="rgba(14, 30, 37, 0.1) 0px 0px 0px 0px"
                >
                  {/* <FaRobot color="white" fontSize={"16px"} /> */}
                  <SiNuget
                    color={
                      isColorDark(botDetails?.accentColor) ? "white" : "black"
                    }
                  />
                </Box>

                <Text fontSize={"13px"} style={{ color: "black" }}>
                  {conversationStart.isStart
                    ? "You have new messages. Tap to view"
                    : botDetails.welcomeMessage}
                </Text>
              </Box>
            </Box>
          ) : null}

          {/* bot load */}

          {!botOpen &&
            (!botDetails?.rufus ||
              !isMobile ||
              !hideBot ||
              !window.meta?.product?.id) && (
              <Box
                disabled={window.meta?.product?.id && isMobile }
                borderRadius={"30px"}
                w={"60px"}
                h={"60px"}
                marginTop={"16px"}
                style={{
                  background: botDetails.accentColor,
                  color: isColorDark(botDetails?.accentColor)
                    ? "white"
                    : "black",
                }}
                display={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
                float={"right"}
                boxShadow={
                  "rgba(60, 64, 67, 0.3) 0px 0px 10px 0px, rgba(60, 64, 67, 0.15) 0px 0px 6px 2px"
                }
                // boxShadow={`rgba(14, 30, 37, 0.12) 0px 0px 0px 0px, ${botDetails.accentColor} 0px 1px 4px 0px`}
                cursor={"pointer"}
                onClick={()=>{
                  if(!loading1)openChatBot();
                }}
              >
                {
                  botDetails.bubbleIcon && botDetails.bubbleIcon !== "" ? (
                    <>
                      {" "}
                      {conversationStart.isStart && !triviaDetails.isActive && (
                        <Box
                          style={{
                            // padding: "3px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            borderRadius: "50%",
                            fontWeight: "bold",
                            height: "25px",
                            width: "25px",
                            background: "red",
                            position: "absolute",
                            right: "0%",
                            color: "white",
                            bottom: 35,
                            zIndex: 3,
                          }}
                        >
                          1
                        </Box>
                      )}
                      <Box position="relative" display="inline-block">
                        <Box
                          position="absolute"
                          zIndex={99912930218313}
                          style={{ display: "block" }}
                          transform="translate(-50%, -50%)"
                        >
                          {[...Array(3)].map((_, i) => (
                            <MotionDiv
                              key={i}
                              style={{
                                position: "absolute",
                                display: "block",
                                width: "30px",
                                height: "30px",
                                borderRadius: "50%",
                                background: botDetails.accentColor,
                                opacity: 0.6,
                                zIndex: 99912930218313,
                              }}
                              animate={{
                                scale: [1, 3.5],
                                opacity: [0.6, 0],
                              }}
                              transition={{
                                duration: 1.8,
                                repeat: Infinity,
                                repeatType: "mirror", // 🔹 Smoothly reverses the animation
                                delay: i * 0.4,
                                ease: [0.4, 0, 0.2, 1],
                              }}
                            />
                          ))}
                        </Box>

                        <Box position={"relative"} zIndex={2147483649}>
                          {loading1 ? (
                            <Spinner
                              size={"lg"}
                              color={
                                isColorDark(botDetails?.color)
                                  ? "white"
                                  : "black"
                              }
                            />
                          ) : (
                            <BotLogo
                              botDetails={botDetails}
                              zIndex={2}
                              isColorDark={isColorDark}
                            />
                          )}
                        </Box>
                      </Box>
                    </>
                  ) : (
                    <>
                      <TfiHeadphoneAlt />
                      {/* <botDetails.bubbleIcon /> */}
                      {/* <Image
                    src={botDetails.companyLogo}
                    w={"28px"}
                    // h={"30px"}
                    // mr={"10px"}
                  /> */}
                    </>
                  )
                  // )
                }
              </Box>
            )}
          {clicked && hideBot && isMobile && (
            <Box position="relative" w="60px" h="60px">
              {particles.map(({ id, x, y, scale }) => (
                <motion.div
                  key={id}
                  initial={{ opacity: 1 }}
                  animate={{
                    x,
                    y,
                    opacity: 0,
                    scale,
                    rotate: Math.random() * 360,
                  }}
                  transition={{ duration: 1.2, ease: "easeOut" }}
                  style={{
                    display: "block",
                    position: "absolute",
                    width: "10px",
                    height: "10px",
                    backgroundColor: botDetails.accentColor,
                    borderRadius: "50%",
                  }}
                />
              ))}
            </Box>
          )}
        </Box>
      </Box>
    )
  );
}
